var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemoveIcpIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6B7280",
  d: "M6.713 6.006 9.36 3.36a.5.5 0 1 0-.707-.707L6.006 5.299 3.36 2.653a.5.5 0 0 0-.707.707l2.646 2.646-2.646 2.647a.5.5 0 1 0 .707.707l2.646-2.647L8.653 9.36a.5.5 0 0 0 .707-.707z"
})));
export { SvgRemoveIcpIcon as ReactComponent };
export default __webpack_public_path__ + "ff83a565b8b45a1eee05313865dc3c7d.svg";